import "@awesome.me/webawesome/dist/components/button/button.js";
import "@awesome.me/webawesome/dist/components/spinner/spinner.js";
import { css, html, LitElement } from "lit";
import { classMap } from "lit/directives/class-map.js";

export class BlLoadButton extends LitElement {
  static get properties() {
    return {
      isLoading: { type: Boolean },
      hasMore: { type: Boolean },
      buttonText: { type: String, attribute: "button-text" },
    };
  }

  static get styles() {
    return css`
      .hidden {
        display: none;
      }

      .spinner-container {
        display: flex;
        justify-content: center;
        margin-top: 16px;
      }

      .button-container {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    `;
  }

  constructor() {
    super();
    this.isLoading = false;
    this.hasMore = false;
    this.buttonText = "Load more";
  }

  render() {
    return html` <div class="button-container">${this.renderButton()} ${this.renderSpinner()}</div> `;
  }

  renderButton() {
    const buttonClasses = {
      hidden: this.isLoading || !this.hasMore,
    };

    return html`
      <wa-button appearance="filled" class="${classMap(buttonClasses)}" @click=${this.handleButtonClick}>
        ${this.buttonText}
      </wa-button>
    `;
  }

  renderSpinner() {
    if (this.isLoading) {
      return html`
        <div class="spinner-container">
          <wa-spinner></wa-spinner>
        </div>
      `;
    } else {
      return html``;
    }
  }

  handleButtonClick() {
    this.isLoading = true;
    const event = new CustomEvent("load-button-clicked", {
      detail: {
        command: "load",
      },
    });
    this.dispatchEvent(event);
  }
}

customElements.define("bl-load-button", BlLoadButton);
